export default Object.freeze({
  Queued: 1,
  Processing: 2,
  Sent: 3,
  Error: 4,
  Skipped: 5,
  Failed: 6,
});
